<template>
<div>
    <template v-if="is_showBtn">
      <v-btn
        @click.stop="showDialog(reserve_id)"
        class="mygreen"
        dark
      >
            <img class="img" src="/img/icon_monsin2.svg" style="margin-left: -6px;margin-right:6px;height:26px;" />
        <span>問診内容</span></v-btn>
    </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center mygreen"
          dark><span class="text-center">問診内容</span></v-toolbar>
        <v-card-text class="pb-0">
          <v-container class="pb-0">
            <v-row>

              <v-col class="text-left" cols="3">診療内容</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                <v-select outlined
                    :items="def_shinryounaiyou"
                    v-model="data.shinryounaiyou"
                    label=""></v-select>
              </v-col>


              <v-col class="text-left" cols="3">来院理由</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_raiin_reasons" :key="v.id">
                      <v-checkbox
                          v-model="data.raiin_reasons"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">診察希望</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_shinsatu_kibou" :key="v.id">
                      <v-checkbox
                          v-model="data.shinsatu_kibou"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>

              <v-col class="text-left" cols="3">他医院通院中</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                            <v-radio-group
                            v-model="data.hoka_tuuinn"
                            row
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    label="はい"
                                    value="はい"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="いいえ"
                                    value="いいえ"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                            </v-radio-group>
              </v-col>

              <v-col class="text-left" cols="3">服用中のお薬</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                            <v-radio-group
                            v-model="data.okusuri"
                            row
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    label="はい"
                                    value="はい"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="いいえ"
                                    value="いいえ"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                            </v-radio-group>
              </v-col>
              <v-col class="text-left" cols="3">アレルギーの有無</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                            <v-radio-group
                            v-model="data.allergies"
                            row
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    label="はい"
                                    value="はい"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="いいえ"
                                    value="いいえ"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                            </v-radio-group>
              </v-col>


              <v-col class="text-left" cols="3">麻酔副作用の経験</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                            <v-radio-group
                            v-model="data.masui"
                            row
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    label="はい"
                                    value="はい"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="いいえ"
                                    value="いいえ"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                            </v-radio-group>
              </v-col>
              <v-col class="text-left" cols="3">妊娠の可能性</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                            <v-radio-group
                            v-model="data.ninshin"
                            row
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    label="はい"
                                    value="はい"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="妊娠中"
                                    value="妊娠中"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="授乳中"
                                    value="授乳中"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                                <v-radio
                                    label="いいえ"
                                    value="いいえ"
                                    color="rgba(0, 189, 242, 1)"
                                ></v-radio>
                            </v-radio-group>
              </v-col>


              <v-col class="text-left" cols="3">来院きっかけ</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_raiin_from" :key="v.id">
                      <v-checkbox
                          v-model="data.raiin_from"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">その他希望</v-col>
              <v-col cols="9" >
                            <v-textarea
                            label="メモ"
                            v-model="data.youbou"
                            outlined></v-textarea>
              </v-col>



            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            class="mygreen"
            @click="save()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */

export default {
    props: {
      is_showBtn: Boolean,
      reserve_id: String,
    },
    created(){
        console.log('%ccreated: DialogMonshinnaiyou.vue', mycolor.purple);
    },
    // datas
    data() { 
    return {
        dialog: false,
        def_shinryounaiyou: ['治療', '検診・クリーニング', 'インプラント・矯正等の相談'],
        def_raiin_reasons: [
            {id: 1, name: "歯が痛い・しみる・虫歯"},
            {id: 2, name: "歯茎が痛い・腫れた・血が出る"},
            {id: 3, name: "かぶせ物が痛い・取れた・壊れた"},
            {id: 4, name: "歯の抜けたところを治したい"},
            {id: 5, name: "入れ歯が壊れた"},
            {id: 6, name: "入れ歯が合わない"},
            {id: 7, name: "新しい入れ歯を作りたい"},
            {id: 8, name: "歯の掃除をしたい・歯石を取りたい"},
            {id: 9, name: "歯並びが気になる"},
            {id: 10, name: "ホワイトニングをしたい"},
            {id: 11, name: "お口の中の検査をしたい"},
            {id: 12, name: "その他"},
        ],
        def_raiin_from: [
            {id: 1, name: "家族・知人の紹介"},
            {id: 2, name: "家・保育園・会社が近い"},
            {id: 3, name: "ホームページ"},
            {id: 4, name: "その他"},
        ],
        def_shinsatu_kibou: [
            {id: 1, name: "通院回数を少なくしたい"},
            {id: 2, name: "治療中は必ず麻酔をかけて欲しい"},
            {id: 3, name: "保険の範囲で治したい"},
            {id: 4, name: "保険外の選択肢があっても良い"},
        ],
        data:{
            reserve_id: '',
            shinryounaiyou: '',   // 診療内容
            hoka_tuuinn: '',      // 他医院通院
            okusuri: '',          // 服用中のお薬
            allergies: '',        // アレルギーの有無
            masui: '',            // 麻酔副作用の経験
            ninshin: '',          // 妊娠の可能性
            youbou: '',           // その他要望

            raiin_reasons: [],    // 来院理由
            raiin_from: [],       // 来院きっかけ
            shinsatu_kibou: [],   // 診察希望
        }

    }},  // datas

    methods: {
        save(){
            console.log('save');
            console.log(this.data);
            this.$emit('submit_monshin', this.data);
            this.dialog = false;
        },
        showDialog(reserve_id){
            console.log('%c showDialog()', 'background: orange;');
            this.dialog = true;
            console.log('reserve_id', reserve_id);
            this.data.reserve_id = reserve_id;


            axios.get( '/reserve/' + reserve_id )
              .then((res) => {
                console.group();
                console.log('%c %s', mycolor.api, '/reserve');
                console.log('問診票データ取得完了');
                console.log(res.data);
                console.groupEnd();


                // todo: もしデータ取れなかったら?
                if(res.data){
                    for (const [key, value] of Object.entries(res.data)) {
                      if( key in this.data ){
                          console.log(key)
                          this.data[key] = value;
                      }
                    }
                }

                console.log('this.data', this.data);


              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
        },

    }, // methods

}
</script>

<style scoped>
.v-input.theme--light.v-input--selection-controls.v-input--checkbox {
    margin: 0;
    height: 40px;
}
.v-input--selection-controls.v-input{
    margin: 0;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .v-list-item__content{
    text-align: left;
}
</style>
